<template>
    <div id="desktopCatch">
        <div id="desktopCatch__modal">
            <img id="desktopCatch__modal__image" src="../assets/popup-heading.png" />
            <h1>Installeer RTV Parkstad</h1>
            <p>Scan de onderstaande QR-code om de app te downloaden.</p>
            <img id="desktopCatch__modal__qr-code" src="@/assets/popup-qr-code.svg"/>
        </div>
        <a id="desktopCatch__powered" href="https://www.tappir.nl">
            <h2>Powered by TAPPIR</h2>
            <img src="@/assets/tappir-logo.svg"/>
        </a>
    </div>
</template>

<script>
export default {
    name: "DesktopCatch",
};
</script>

<style lang="scss" scoped>
#desktopCatch {
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    background: url("../assets/desktopcatch/desktop-catch-background.png");
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    #desktopCatch__modal {
        background-color: white;
        width: 300px;
        height: 330px;
        padding: 16px;
        box-sizing: border-box;
        border-radius: 5px;
        box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);
        font-family: "Lato";

        #desktopCatch__modal__image {
            width: 100%;
        }

        h1 {
            text-align: center;
            font-size: 20px;
        }

        p {
            text-align: center;
            font-size: 16px;
        }

        #desktopCatch__modal__qr-code {
            width: 120px;
            height: 120px;
            margin: 10px 74px 0px 74px;
        }
    }

    #desktopCatch__powered {
        background-color: #F1F1F1;
        margin-top: -5px;
        width: 300px;
        height: 60px;
        z-index: -1;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        box-sizing: border-box;
        padding-top: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;

        h2 {
            font-family: "Fira Sans";
            font-size: 18px;
            color: #3a3c39;
            margin-right: 10px;
        }
        img {
            height: 32px;
            display: inline;
        }
    }

    #desktopCatch__powered:hover {
        background-color: #E2E2E2;
    }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #desktopCatch {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #desktopCatch {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #desktopCatch {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #desktopCatch {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #desktopCatch {
       
    }
}
</style>